import { useNavigate } from 'react-router-dom'
import { useState } from 'react';

import { MdOutlineLanguage } from 'react-icons/md'
import { BiCategoryAlt } from 'react-icons/bi'
import { CgCalendarDates } from 'react-icons/cg'
import { FiEdit3, FiDownload } from 'react-icons/fi'
import { IoIosMore } from 'react-icons/io'

import useAuth from './../../hooks/useAuth';
import GetPoster from '../types/GetPoster'
import FixPanel from '../FixPanel';

import moment from 'moment/moment';
import 'moment/locale/fa'  // without this line it didn't work
import { AiFillPushpin } from 'react-icons/ai';




export const removeHTML_tags = (str = '') => {
  if ((str === null) || (str === ''))
    return false;
  else
    return str.replace(/(<([^>]+)>)/ig, '');
}


const ItemsType = ({ data }) => {

  const [panelDownload, setPanelDownload] = useState(false)
  const [dataDownload, setDataDownload] = useState([])
  const [titleDownload, setTitleDownload] = useState('')
  const [postID, setPostID] = useState('')
  const [subjectTypeDownload, setSubjectTypeDownload] = useState(null)
  const [videosDownload, setVideosDownload] = useState([])
  const [videoDownload, setVideoDownload] = useState(null)


  const navigate = useNavigate()
  const { auth } = useAuth()


  const handleLinkDownloads = (data) => {
    setTitleDownload(data.title)
    setDataDownload(data.subjectBranch)
    setPanelDownload(true)
    setPostID(data.id)
    setSubjectTypeDownload(data.type)
    setVideosDownload(data.videos || [])
    setVideoDownload(data.video || null)
  }


  return (
    <>

      <FixPanel
        title={titleDownload}
        data={dataDownload}
        post_id={postID}
        show={panelDownload}
        onClose={() => setPanelDownload(false)}
        subjectType={subjectTypeDownload}
        videos={videosDownload}
        video={videoDownload}
      />

      {data.map(i => (
        <div
          key={i.id}
          className='itemBox'
          style={{ fontStyle: 'normal' }}
        >
          <div className='dtr'>
            <div className='flex'>
              <GetPoster id={i.posterId} />
              <div
                className='contentItem'
                style={{ maxHeight: 'auto' }}
              >
                <div className='title'>
                  {i.isPin && <AiFillPushpin style={{ position: 'absolute', top: -10, right: -10 }} />}
                  <h2 className='ellipsis'>{i.title} {i.persianTitle ? (<><small className='ellipsis'>({i.persianTitle})</small> </>) : ''}</h2>
                  {i.state?.id === 1 && <span>{i.state?.title}</span>}
                </div>

                {i.persianTitle ? (
                  <p className='visible-xs'>
                    <MdOutlineLanguage />
                    <span>
                      نام فارسی : <b>{i.persianTitle}</b>
                    </span>
                  </p>
                ) : (
                  ''
                )}

                <div style={{ marginBottom: '8px' }} className='cats'><BiCategoryAlt />
                  {i.categories && (
                    <ul>
                      {i.categories.map(i => (
                        <li key={i.id}>{i.title}</li>
                      ))}
                    </ul>
                  )}
                  {i.productionYear && <>
                    <span style={{ margin: '0 5px', fontSize: 23, lineHeight: 0, color: '#999' }}>-</span>
                    <span>{i.productionYear}</span>
                  </>}

                  {i.size > 0 && <>
                    <span style={{ margin: '0 5px', fontSize: 23, lineHeight: 0, color: '#999' }}>-</span>
                    <span>{i.size} گیگابایت</span>
                  </>}

                  {i.version && <><span style={{ margin: '0 5px', fontSize: 23, lineHeight: 0, color: '#999' }}>-</span>
                    <span>نسخه : {i.version}</span></>}

                  {i.ages && <span style={{ marginRight: 10 }} className='ages'>{i.ages}</span>}

                </div>


                {i.productionYear ? (
                  <p className='visible-xs'>
                    <CgCalendarDates />
                    <span>
                      سال انتشار : <b>{i.productionYear}</b>
                    </span>
                  </p>
                ) : ''}


                {i.description ? (
                  <p className='hidden-xs'>
                    <span className='ellipsis-2line' style={{ lineHeight: '25px', fontSize: '14px' }}>{removeHTML_tags(i.description)}</span>
                  </p>

                ) : ''}


                <div className='cats'>
                  {i.publishDate && <>
                    <span>{moment(i.publishDate).locale('fa').fromNow()}</span>

                    {i.producerName && <><span style={{ margin: '0 5px', fontSize: 23, lineHeight: 0, color: '#999' }}>-</span>
                      <span>{i.producerName}</span></>}

                    {i.branchGroup?.length > 0 && <><span style={{ margin: '0 5px', fontSize: 23, lineHeight: 0, color: '#999' }}>-</span>
                      <span>{i.branchGroup}</span></>}

                    {i.featureItems?.length > 0 && <><span style={{ margin: '0 5px', fontSize: 23, lineHeight: 0, color: '#999' }}>-</span>
                      {i.featureItems.map(i => {return <span className='featureItemType' style={{backgroundColor: 'var(--theme-color-1)', borderRadius: '5px', padding: '1px 6px', color: '#fff',marginLeft: '10px'}} key={i.id}>{i.title} </span>})}</>}

                  </>}
                </div>



              </div>
            </div>
          </div>
          <div className='dtl'>


            {auth?.role[0] === 'ADMIN' ?
              <button onClick={() => navigate(`/type/edit/${i.id}`)}><span className='descBTN'>ویرایش</span><span className='mobBTN'><FiEdit3 /></span></button>
              : ''}


            {i.subjectBranch.length > 0 && (<button onClick={() => handleLinkDownloads(i)}><span className='descBTN'>لینک دانلود</span><span className='mobBTN'><FiDownload /></span></button>)}

            <button className='bordered' onClick={() => { navigate(`${i.id}`) }}><span className='descBTN'>جزئیات بیشتر</span><span className='mobBTN'><IoIosMore /></span></button>


          </div>
        </div>
      ))
      }
    </>
  )
}

export default ItemsType
